export { NAV_HEIGHT as TOP_NAV_HEIGHT } from 'Layout/MyAccountLayout/dimensions';
export const LEFT_MENU_WIDTH = 215;
export const NAV_MENU_HEIGHT = 95;
export const HOME_FOLD_NAME = 'Home';
export const TRASH_FOLD_NAME = 'Trash';
